import React from "react";
import styled, { keyframes, css } from "styled-components";
import colgateLogo from "../media/img/colgateLogobb.png";
import amfamLogo from "../media/img/amfamLogobb.png";
import palmoliveLogo from "../media/img/palmoliveLogobb.png";
import seacretLogo from "../media/img/seacretLogobb.png";
import classDojLogo from "../media/img/classDojLogobbW.png";
import impactiveLogo from "../media/img/impactivebb.png";
import bioplusLogo from "../media/img/bioplusLogobb.png";
import pmInterLogo from "../media/img/pmInterbb.png";
import socialrootsLogo from "../media/img/socialrootsbb.png";
import elevateHTLogo from "../media/img/elevateHTbb.png";
import patternAgLogo from "../media/img/patternAgbb.png";
import zinzinoLogo from "../media/img/zinzinoLogobb.png";

// Subtle float animation for logos
const float = keyframes`
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-5px) scale(1.05);
  }
`;

// Seamless infinite scroll animation
const scrollInfinite = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

// Shine effect animation
const shine = keyframes`
  0% {
    background-position: -200px;
  }
  100% {
    background-position: 400px;
  }
`;

const StripContainer = styled.div`
  position: absolute;
  top: 40%;
  left: -1rem;
  width: 101.5%;
  overflow: hidden;
  white-space: nowrap;
  transform: rotate(2deg);
  background: linear-gradient(90deg, 
    rgba(2, 73, 95, 0.7), 
    rgba(4, 121, 157, 0.75),
    rgba(5, 143, 186, 0.8),
    rgba(4, 121, 157, 0.75),
    rgba(2, 73, 95, 0.7)
  );
  backdrop-filter: blur(8px);
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 5px 0;
  z-index: 10;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, 
      rgba(255, 255, 255, 0) 0%, 
      rgba(255, 255, 255, 0.05) 25%, 
      rgba(255, 255, 255, 0.1) 50%, 
      rgba(255, 255, 255, 0.05) 75%, 
      rgba(255, 255, 255, 0) 100%);
    animation: ${shine} 8s linear infinite;
    pointer-events: none;
  }

  @media (max-width: 1800px) {
    top: 55rem;
  }

  @media (max-width: 1500px) {
    top: 50rem;
  }

  @media (max-width: 1200px) {
    top: 45rem;
    transform: rotate(1deg);
  }

  @media (max-width: 991px) {
    top: 40rem;
  }

  @media (max-width: 768px) {
    top: 32rem;
    width: 102%;
  }

  @media (max-width: 600px) {
    top: 26rem;
    width: 103%;
    transform: rotate(0.5deg);
  }

  @media (max-width: 480px) {
    top: 22rem;
    width: 104%;
    transform: rotate(0deg);
  }
`;

// This wrapper contains the duplicate set of logos for seamless scrolling
const InfiniteLogoTrack = styled.div`
  display: inline-block;
  white-space: nowrap;
  animation: ${scrollInfinite} 40s linear infinite;
  will-change: transform;
`;

const LogoContainer = styled.div`
  display: inline-block;
  position: relative;
  margin: 0 25px;
  vertical-align: middle;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.15) translateY(-5px);
    z-index: 2;
  }
`;

const Logo = styled.img`
  height: 55px;
  filter: brightness(1.05) drop-shadow(0 5px 15px rgba(0, 0, 0, 0.2));
  transition: all 0.3s ease;
  animation: ${float} 3s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;
  
  ${LogoContainer}:hover & {
    filter: brightness(1.2) drop-shadow(0 8px 20px rgba(0, 0, 0, 0.3));
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    height: 45px;
  }

  @media (max-width: 480px) {
    height: 35px;
    margin: 0 15px;
  }
`;

const logos = [
  colgateLogo,
  amfamLogo,
  palmoliveLogo,
  seacretLogo,
  classDojLogo,
  impactiveLogo,
  bioplusLogo,
  pmInterLogo,
  socialrootsLogo,
  elevateHTLogo,
  patternAgLogo,
  zinzinoLogo,
];

const LogoStrip = () => {
  // Create a component with duplicate logo sets for seamless infinite scrolling
  const renderLogos = (isSecondSet = false) => {
    return logos.map((logo, index) => (
      <LogoContainer key={`${isSecondSet ? 'dup-' : ''}${index}`}>
        <Logo 
          src={logo} 
          alt={`Logo ${index + 1}`}
          delay={(index * 0.2) % 2} 
        />
      </LogoContainer>
    ));
  };

  return (
    <StripContainer>
      <InfiniteLogoTrack>
        {renderLogos()}
        {renderLogos(true)}
      </InfiniteLogoTrack>
    </StripContainer>
  );
};

export default LogoStrip;
